import {
  StaffAllOverview,
  PillarsHomeOverview,
  ThemesPillarOverview,
  NewsPillarOverview,
  NewsPressReleasesOverview,
  ArticlesPillarOverview,
  OpinionsPillarOverview,
  DownloadsPillarOverview,
  DownloadsPillarAll,
  GroupedContentThemeDetail,
  GroupedContentDetailMore,
  GroupedContentThemeDetailPromoted,
  GroupedContentFrontpagePromoted,
  ArticlesAllOverview,
  DossiersAllOverview,
  ThemesAllOverview,
  DownloadsAllOverview,
  NewsAllOverview,
  NewsRecent,
  NewsPillarAll,
  OpinionsAllOverview,
  OpinionsPillarAll,
  MembersAllOverview,
  CoursesAllOverview,
  ThemesPillarAllOverview,
  ThemesSelectOverview,
  ContentLatest,
  CourseRecent,
  CaoPdfLinksOverview,
} from '../implementations';

const mappers = {
  views_block__pillars_block_1: PillarsHomeOverview,

  views_block__themes_block_1: ThemesPillarOverview,
  views_block__news_block_1: NewsPillarOverview,
  views_block__opinions_block_1: OpinionsPillarOverview,
  views_block__downloads_block_1: DownloadsPillarOverview,
  views_block__articles_block_1: ArticlesPillarOverview,

  views_block__grouped_content_theme_detail: GroupedContentThemeDetail,
  views_block__grouped_content_theme_detail_more: GroupedContentDetailMore,
  views_block__grouped_content_theme_detail_promoted: GroupedContentThemeDetailPromoted,
  views_block__grouped_content_frontpage_promoted: GroupedContentFrontpagePromoted,

  views_block__staff_all: StaffAllOverview,

  views_block__members_all: MembersAllOverview,
  views_block__members_list_all: MembersAllOverview,

  views_block__news_press_releases: NewsPressReleasesOverview,
  views_block__articles_all: ArticlesAllOverview,
  views_block__themes_all: ThemesAllOverview,
  views_block__downloads_all: DownloadsAllOverview,
  views_block__news_all: NewsAllOverview,
  views_block__opinions_all: OpinionsAllOverview,
  views_block__courses_block: CoursesAllOverview,
  views_block__course_info_overview_block_1: CoursesAllOverview,
  views_block__dossiers_filtered_dossiers_filtered: DossiersAllOverview,

  views_block__themes_select: ThemesSelectOverview,

  views_block__news_pillar_all: NewsPillarAll,
  views_block__themes_pillar_all: ThemesPillarAllOverview,
  views_block__articles_pillar_all: ArticlesAllOverview,
  views_block__opinions_pillar_all: OpinionsPillarAll,
  views_block__downloads_pillar_all: DownloadsPillarAll,
  views_block__news_recent: NewsRecent,
  views_block__news_pinned_recent: NewsRecent,
  views_block__latest_content_all: ContentLatest,
  views_block__latest_content_by_expert: GroupedContentDetailMore,
  views_block__latest_content_by_dossier: GroupedContentDetailMore,
  views_block__courses_recent: CourseRecent,

  views_block__cao_pdf_links_overview: CaoPdfLinksOverview,
};

export default mappers;
